import React, { useState, useEffect, useCallback } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Sidebar from '../Components/Sidebar/Sidebar';
import axios from 'axios';

import '../Chamado/ChamadoPage.css';
import './historicoSatiFechada.css';
import ListaAnexos from '../Components/ListaAnexos/listaAnexos';
import ChamadoTimeline from '../Chamado/ChamadoTimeline';
import ChamadoSidebar from '../Chamado/ChamadoSidebar';
import ChamadoAttachmentField from '../../Solicitante/NovaSati/components/ChamadoAttachmentField';
import { mensagemErroAnexo } from '../../FuncoesGerais/anexoArquivo';
import { ModalAlert, ModalRetomarAtendimento } from '../Components/ModalSistema';
import { useStatusChamado } from '../../hooks/useStatusChamado';

import verificandoToken from '../../FuncoesGerais/VerificarToken';
import verificandoApp from '../../FuncoesGerais/verificaApp';
import { ensureProtocol } from '../../config/backend';

function formatarTempoSegundos(totalSegundos) {
    const s = Math.max(0, Math.floor(Number(totalSegundos) || 0));
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    const sec = s % 60;
    if (h > 0) return `${h}h ${String(m).padStart(2, '0')}m`;
    if (m > 0) return `${m}m ${String(sec).padStart(2, '0')}s`;
    return `${sec}s`;
}

function HistoricoSatiFechada(props) {
    const history = useHistory();
    const id = props.match.params.id;
    const { statusParaSelect, getNome: getNomeStatus } = useStatusChamado();

    const verificar = useCallback(async () => {
        const resultado = await verificandoApp('ATENDENTE');
        if (!resultado) history.push('/');
    }, [history]);

    const [data, setData] = useState([]);
    const [satDesSol, setSatDesSol] = useState('');
    const [usrNomCpl, setUsrNomCpl] = useState('');
    const [tipoNome, setTipoNome] = useState('');
    const [atendenteNome, setAtendenteNome] = useState('');
    const [statusAtual, setStatusAtual] = useState(null);
    const [sprintId, setSprintId] = useState(null);
    const [sprintNome, setSprintNome] = useState('');
    const [estimativaHoras, setEstimativaHoras] = useState(null);
    const [tempoTrabalhadoTexto, setTempoTrabalhadoTexto] = useState('');
    const [anexos, setAnexos] = useState([]);
    const [novoAnexoBase64, setNovoAnexoBase64] = useState('');
    const [novoAnexoNome, setNovoAnexoNome] = useState('');
    const [novoAnexoInterno, setNovoAnexoInterno] = useState(false);
    const [salvandoAnexo, setSalvandoAnexo] = useState(false);
    const [modalAlert, setModalAlert] = useState({ show: false, title: 'Aviso', message: '' });
    const [resumoChamado, setResumoChamado] = useState('');
    const [resumoLoading, setResumoLoading] = useState(false);
    const [showRetomar, setShowRetomar] = useState(false);
    const [retomarLoading, setRetomarLoading] = useState(false);

    const iaHabilitada = localStorage.getItem('ia_habilitada') !== '0';
    const baseUrlAnalista = () => (localStorage.getItem('ipBackend2') ? ensureProtocol(localStorage.getItem('ipBackend2')) : '');

    const fetchAnexos = useCallback(async () => {
        if (!id) return;
        verificandoToken();
        const token = localStorage.getItem('token');
        try {
            const response = await axios.get(baseUrlAnalista() + '/anexos', {
                headers: { Authorization: token },
                params: { satNum: id },
            });
            const lista = Array.isArray(response.data) ? response.data : [];
            setAnexos(lista.map((item) => ({
                satNum: item.SATNUM ?? item.satNum,
                seqAne: item.SEQANE ?? item.seqAne,
                seqHis: item.SEQHIS ?? item.seqHis,
                nomArq: item.NOMARQ ?? item.nomArq,
                arquivo: item.ARQUIVO ?? item.arquivo ?? item.Arquivo64,
                interno: !!(item.INTERNO === 1 || item.interno === 1),
            })));
        } catch (err) {
            console.error('Erro ao buscar anexos:', err);
            setAnexos([]);
        }
    }, [id]);

    const fetchData = useCallback(async () => {
        if (!id) return;
        verificandoToken();
        const token = localStorage.getItem('token');
        try {
            const response = await axios.get(baseUrlAnalista() + '/satHis', {
                headers: { Authorization: token },
                params: { satNum: id },
            });
            const rows = Array.isArray(response.data) ? response.data : [];
            setData(rows.map((r) => ({
                descricao: r.SATDESSLI ?? r.satdessli ?? '',
                data: r.SATDATFEC ?? r.satdatfec ?? '',
                codHis: r.CODHIS ?? r.codhis,
                autor_nome: r.autor_nome ?? r.AUTOR_NOME ?? null,
                interno: !!(r.INTERNO === 1 || r.interno === 1),
            })));
        } catch (err) {
            console.error('Erro ao buscar histórico:', err);
        }
    }, [id]);

    const carregarChamado = useCallback(async () => {
        if (!id) return;
        verificandoToken();
        const token = localStorage.getItem('token');
        try {
            const response = await axios.get(baseUrlAnalista() + '/satis/unica', {
                headers: { Authorization: token },
                params: { satNum: id },
            });
            const sat = response.data && response.data[0];
            if (!sat) return;
            const satNumVal = sat.SATNUM ?? sat.satNum ?? 0;
            if (satNumVal > 0) {
                setSatDesSol(sat.SATDESSOL ?? sat.satdessol ?? '');
                setTipoNome((sat.tipo_nome ?? sat.TIPO_NOME ?? '').toString().trim());
                setAtendenteNome((sat.atendente_nome ?? sat.ATENDENTE_NOME ?? '').toString().trim());
                setStatusAtual(sat.SATSTASAI ?? sat.sat_stasai ?? null);

                const minutos = sat.tempo_trabalhado_minutos != null ? Number(sat.tempo_trabalhado_minutos) : 0;
                setTempoTrabalhadoTexto(formatarTempoSegundos(minutos * 60));

                const sid = sat.sprint_id ?? sat.SPRINT_ID ?? sat.sprint?.id ?? null;
                const snome = (sat.sprint_nome ?? sat.SPRINT_NOME ?? sat.sprint?.nome ?? '').toString().trim() || '';
                const ehoras = sat.estimativa_horas ?? sat.ESTIMATIVA_HORAS;
                setSprintId(sid != null && sid !== '' && !Number.isNaN(Number(sid)) ? Number(sid) : null);
                setSprintNome(snome);
                setEstimativaHoras((ehoras != null && ehoras !== '' && !Number.isNaN(Number(ehoras))) ? Number(ehoras) : null);

                const codUsuSol = sat.SATUSUSOL ?? sat.satususol;
                if (codUsuSol) {
                    try {
                        const r2 = await axios.get(baseUrlAnalista() + '/usuarios', {
                            headers: { Authorization: token },
                            params: { codUsu: codUsuSol },
                        });
                        if (r2.data && r2.data[0]) {
                            const u = r2.data[0];
                            setUsrNomCpl((u.USRNOMCPL ?? u.usrnomcpl ?? '').toString().trim());
                        }
                    } catch (_) {}
                }
            }
        } catch (err) {
            console.error('Erro ao carregar chamado:', err);
        }
    }, [id]);

    const buscarResumo = useCallback(async () => {
        const url = baseUrlAnalista();
        if (!url) return '';
        setResumoLoading(true);
        setResumoChamado('');
        verificandoToken();
        const token = localStorage.getItem('token');
        const tramites = (data || []).map((t) => t.descricao || t.SATDESSLI || '');
        try {
            const response = await axios.post(url + '/satis/resumo-chamado', { descricao: (satDesSol || '').trim(), tramites }, { headers: { Authorization: token } });
            const texto = (response.data?.resumo || '').trim();
            setResumoChamado(texto);
            return texto;
        } catch (err) {
            console.error('Erro ao buscar resumo:', err);
            setResumoChamado('');
            return '';
        } finally {
            setResumoLoading(false);
        }
    }, [data, satDesSol]);

    const abrirResumoParaImpressao = useCallback(async () => {
        let texto = resumoChamado || '';
        if (!texto.trim()) {
            if ((satDesSol || '').trim().length < 2) {
                alert('A descrição do chamado é necessária para gerar o resumo. Tente novamente.');
                return;
            }
            texto = await buscarResumo();
        }
        if (!texto.trim()) {
            alert('Não foi possível gerar o resumo. Tente novamente.');
            return;
        }
        const titulo = `Chamado #${id} — Resumo`;
        const janela = window.open('', '_blank', 'width=700,height=500,scrollbars=yes');
        if (!janela) {
            alert('Permita pop-ups para abrir a tela de impressão.');
            return;
        }
        janela.document.write(`
<!DOCTYPE html>
<html>
<head><meta charset="utf-8"><title>${titulo}</title>
<style>body{font-family:Arial,sans-serif;margin:24px;max-width:650px;}h1{font-size:1.25rem;color:#0d6efd;} .resumo{white-space:pre-wrap;line-height:1.5;margin:16px 0;} .meta{font-size:0.875rem;color:#6c757d;} @media print{.no-print{display:none;}}</style>
</head>
<body>
<h1>Chamado #${id}</h1>
<p class="meta">Resumo gerado por IA</p>
<div class="resumo">${String(texto).replace(/</g, '&lt;').replace(/>/g, '&gt;')}</div>
<p class="meta">Imprima esta página (Ctrl+P) ou feche quando terminar.</p>
<button class="no-print" onclick="window.print()" style="margin-top:12px;padding:8px 16px;cursor:pointer;">Imprimir</button>
<button class="no-print" onclick="window.close()" style="margin-left:8px;padding:8px 16px;cursor:pointer;">Fechar</button>
</body>
</html>`);
        janela.document.close();
    }, [id, resumoChamado, satDesSol, buscarResumo]);

    const executarRetomarAtendimento = useCallback(async (motivo) => {
        verificandoToken();
        const token = localStorage.getItem('token');
        setRetomarLoading(true);
        try {
            await axios.put(
                baseUrlAnalista() + '/satis/retornarAtendimento',
                { satNum: id, motivo },
                { headers: { Authorization: token } }
            );
            setShowRetomar(false);
            history.push(`/historicoSati/${id}`);
        } catch (err) {
            console.error('Erro ao retomar chamado:', err);
            setModalAlert({
                show: true,
                title: 'Erro',
                message: err.response?.data?.error || 'Não foi possível retomar o atendimento. Tente novamente.',
            });
        } finally {
            setRetomarLoading(false);
        }
    }, [id, history]);

    const adicionarAnexoNoCard = useCallback(async () => {
        if (!id || !novoAnexoBase64 || !novoAnexoNome?.trim()) return;
        verificandoToken();
        const token = localStorage.getItem('token');
        const baseUrl = baseUrlAnalista();
        if (!baseUrl) return;
        setSalvandoAnexo(true);
        try {
            await axios.post(baseUrl + '/anexos', {
                satNum: id,
                nomArq: novoAnexoNome.trim(),
                Arquivo64: novoAnexoBase64,
                interno: novoAnexoInterno,
            }, { headers: { Authorization: token } });
            setNovoAnexoBase64('');
            setNovoAnexoNome('');
            setNovoAnexoInterno(false);
            fetchAnexos();
        } catch (err) {
            console.error('Erro ao adicionar anexo:', err);
            setModalAlert({ show: true, title: 'Erro', message: mensagemErroAnexo(err) });
        } finally {
            setSalvandoAnexo(false);
        }
    }, [id, novoAnexoBase64, novoAnexoNome, novoAnexoInterno, fetchAnexos]);

    useEffect(() => {
        verificar();
        carregarChamado();
        fetchData();
        fetchAnexos();
    }, [verificar, carregarChamado, fetchData, fetchAnexos]);

    const baseUrlDownload = baseUrlAnalista() ? baseUrlAnalista() + '/anexos/download' : null;

    const anexosCardContent = (
        <>
            <h4 className="chamado-sidebar-card-titulo">
                <i className="fas fa-paperclip me-2" /> Anexos {anexos.length > 0 && `(${anexos.length})`}
            </h4>
            {anexos.length === 0 ? (
                <p className="chamado-sidebar-anexos-vazio">Sem anexos para o chamado.</p>
            ) : (
                <div className="chamado-sidebar-anexos-lista">
                    <ListaAnexos
                        arrayAnexos={anexos}
                        satNum={id}
                        baseUrlDownload={baseUrlDownload}
                        nomeClicavel
                        compact
                    />
                </div>
            )}
            <div className="chamado-sidebar-anexos-adicionar">
                <ChamadoAttachmentField
                    id="historico-fechada-anexo-field"
                    nomeArquivo={novoAnexoNome}
                    onFileChange={({ base64, nome }) => { setNovoAnexoBase64(base64 || ''); setNovoAnexoNome(nome || ''); }}
                />
                <label className="chamado-anexos-interno">
                    <input type="checkbox" checked={novoAnexoInterno} onChange={(e) => setNovoAnexoInterno(e.target.checked)} />
                    <span>Anexo interno</span>
                </label>
                <button type="button" className="btn btn-primary btn-sm" onClick={adicionarAnexoNoCard} disabled={salvandoAnexo || !novoAnexoBase64 || !novoAnexoNome?.trim()}>
                    {salvandoAnexo ? 'Enviando...' : 'Adicionar anexo'}
                </button>
            </div>
        </>
    );

    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
                <div className="chamado-page historico-fechada-page">
                    <div className="chamado-page-main">
                        <header className="historico-fechada-header">
                            <h1 className="historico-fechada-titulo">Chamado #{id} — Encerrado</h1>
                            <p className="historico-fechada-subtitulo">
                                {usrNomCpl ? `Solicitante: ${usrNomCpl}` : 'Solicitante: —'}
                                {tipoNome ? ` • Tipo: ${tipoNome}` : ''}
                            </p>
                            <div className="historico-fechada-header-actions">
                                {iaHabilitada && (
                                    <>
                                        <button type="button" className="btn btn-ia btn-sm" onClick={buscarResumo} disabled={resumoLoading} title="Gerar resumo com IA">
                                            {resumoLoading ? 'Gerando...' : 'Gerar resumo'}
                                        </button>
                                        <button type="button" className="btn btn-outline-secondary btn-sm" onClick={abrirResumoParaImpressao} disabled={resumoLoading} title="Abrir resumo para impressão">
                                            <i className="fas fa-print me-1" aria-hidden="true" /> Imprimir resumo
                                        </button>
                                    </>
                                )}
                                <Link to="/satiFechada" className="btn btn-outline-secondary btn-sm">
                                    <i className="fas fa-arrow-left me-1" aria-hidden="true" /> Voltar
                                </Link>
                            </div>
                        </header>

                        {iaHabilitada && (resumoChamado || resumoLoading) && (
                            <div className="historico-fechada-resumo-bar card border-info sugestao-ia-card">
                                <div className="card-body py-2 d-flex justify-content-between align-items-start gap-2 flex-wrap">
                                    <div className="flex-grow-1">
                                        <strong className="text-info">Resumo do chamado (gerado por IA)</strong>
                                        <p className="mb-0 mt-1 texto-sugestao-ia">{resumoLoading ? 'Gerando resumo...' : resumoChamado}</p>
                                    </div>
                                    <div className="d-flex gap-2 align-items-center">
                                        <button type="button" className="btn btn-ia btn-sm" onClick={buscarResumo} disabled={resumoLoading}>Atualizar</button>
                                        <button type="button" className="btn btn-outline-secondary btn-sm" onClick={abrirResumoParaImpressao} disabled={resumoLoading}><i className="fas fa-print me-1" /> Imprimir</button>
                                        <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => setResumoChamado('')} disabled={resumoLoading}><i className="fas fa-times me-1" /> Fechar</button>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="historico-fechada-card-wrap chamado-card-wrap">
                            <div className="chamado-description-card">
                                <label className="form-label text-muted small">Descrição do chamado</label>
                                <textarea readOnly value={satDesSol || ''} className="form-control historico-sati-textarea-grande" rows={6} style={{ resize: 'none' }} />
                            </div>
                        </div>

                        <ChamadoTimeline eventos={data} />

                        <div className="historico-fechada-footer-actions">
                            <Link to="/satiFechada" className="btn btn-secondary">
                                <i className="fas fa-arrow-left me-1" /> Voltar à lista
                            </Link>
                        </div>
                    </div>

                    <ChamadoSidebar
                        chamadoEncerrado
                        statusAtual={statusAtual}
                        statusParaSelect={statusParaSelect}
                        getNomeStatus={getNomeStatus}
                        onStatusChange={() => {}}
                        atendenteNome={atendenteNome}
                        sprintId={sprintId}
                        sprintNome={sprintNome}
                        estimativaHoras={estimativaHoras}
                        tempoTrabalhadoTexto={tempoTrabalhadoTexto}
                        tempoAnaliseTexto="—"
                        tempoTesteTexto="—"
                        emPeriodoAberto={false}
                        emPeriodoAbertoAnalise={false}
                        emPeriodoAbertoTeste={false}
                        tempoTrabalhadoMinutos={0}
                        colaboradores={[]}
                        carregandoColaboradores={false}
                        opcoesColaboradores={[]}
                        novoColaboradorId=""
                        onNovoColaboradorChange={() => {}}
                        onAdicionarColaborador={() => {}}
                        onRemoverColaborador={() => {}}
                        salvandoColaborador={false}
                        carregandoOpcoesColaboradores={false}
                        novoResponsavelId=""
                        onNovoResponsavelChange={() => {}}
                        onAtribuirAtendente={() => {}}
                        salvandoAtribuicaoAtendente={false}
                        onRetomarAtendimento={() => setShowRetomar(true)}
                        retomarLoading={retomarLoading}
                        anexosCard={anexosCardContent}
                    />
                </div>

                <ModalRetomarAtendimento
                    open={showRetomar}
                    onClose={() => !retomarLoading && setShowRetomar(false)}
                    onConfirm={executarRetomarAtendimento}
                    loading={retomarLoading}
                    satNum={id}
                />

                <ModalAlert
                    open={modalAlert.show}
                    onClose={() => setModalAlert({ show: false, title: 'Aviso', message: '' })}
                    title={modalAlert.title}
                    message={modalAlert.message}
                    labelOk="OK"
                />
            </main>
        </div>
    );
}

export default HistoricoSatiFechada;
